import React from 'react';
import Section from './Section';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaGithub } from 'react-icons/fa';

const ProjectCard = ({ project }) => {
  return (
    <motion.article className="card project glass"
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="project-cover" style={{ backgroundImage: `url(${project.image})` }} />
      <div className="project-content">
        <h3>{project.title}</h3>
        <p className="muted">{project.description}</p>
        <ul className="tags">
          {project.tech.map((t) => <li key={t}>{t}</li>)}
        </ul>
        <div className="project-links">
          {project.source && (
            <a href={project.source} target="_blank" rel="noreferrer" className="icon-link">
              <FaGithub /> <span>Code</span>
            </a>
          )}
          {project.demo && (
            <a href={project.demo} target="_blank" rel="noreferrer" className="icon-link">
              <FaExternalLinkAlt /> <span>Live</span>
            </a>
          )}
        </div>
      </div>
    </motion.article>
  );
};

const Projects = ({ projects = [] }) => {
  return (
    <Section id="projects" title="Projects" subtitle="Things I've built">
      <div className="grid three">
        {projects.map((p) => (
          <ProjectCard key={p.id} project={p} />
        ))}
      </div>
    </Section>
  );
};

export default Projects;
